import {useScrollytellState} from "../Admin/scrollytellContext";

export const useIsActiveContainer = ({sectionId, containerId}) => {
    const {activeElement} = useScrollytellState()

    return activeElement[0] === sectionId &&
        activeElement[1] === containerId &&
        activeElement[2] === undefined
}